import api from 'api'

export type CreateIndeedFlexPastShiftWorker = {
  workerId: number
  clockedInAt?: string
  clockedOutAt?: string
  breakDurationMinutes?: number
}

export type CreateIndeedFlexPastShiftParams = {
  ifClientId: number
  ifShiftId: number
  workers: CreateIndeedFlexPastShiftWorker[]
}

export type CreateIndeedFlexPastShiftResponse = {
  shiftIds: number[]
}

export const createIndeedFlexPastShift = async (
  params: CreateIndeedFlexPastShiftParams
): Promise<CreateIndeedFlexPastShiftResponse> => {
  const result = await api.post<CreateIndeedFlexPastShiftResponse>(
    '/admin/indeed_flex/shifts/create_past',
    params
  )
  return result.data
}
